const recharge = {
    path: 'recharge',
    component: resolve => require(['@/pages/admin/storage_audit/recharge.vue'], resolve),
}

export default recharge